import { PageShell } from '@/components/page-shell';

export const UsersPlaceholderPage = () => (
  <div className="p-6">
    <PageShell title="Пользователи" description="Раздел будет добавлен в следующем плане.">
      <div className="p-8 text-center text-muted-foreground">Скоро.</div>
    </PageShell>
  </div>
);
